"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildingLayouts = void 0;
var layouts = [
    { name: 'Apartment', nameChi: '住宅' },
    { name: 'Duplex', nameChi: '複式' },
    { name: 'Triplex', nameChi: '三層複式' },
    { name: 'Penthouse', nameChi: '閣樓' },
    { name: 'House', nameChi: '獨立屋' },
    { name: 'Studio', nameChi: '開放式' },
    { name: 'Village House', nameChi: '村屋' }
];
exports.buildingLayouts = [
    { name: "Apartment", url: "/en/property-search/buy/property-apartment" },
    { name: "Duplex", url: "/en/property-search/buy/property-duplex" },
    { name: "Triplex", url: "/en/property-search/buy/property-triplex" },
    { name: "Penthouse", url: "/en/property-search/buy/property-penthouse" },
    { name: "House", url: "/en/property-search/buy/property-house" },
    { name: "Studio", url: "/en/property-search/buy/property-studio" },
    { name: "Village House", url: "/en/property-search/buy/property-village-house" }
];
